import * as React from 'react';

import * as styles from './SeoMarkedList.css';
import { SeoMarkedListItem } from './components/SeoMarkedListItem';
// eslint-disable-next-line import/no-restricted-paths
import type { IMarkedListTextBlock } from '../../../node/repositories/seo-sections/entities/marked_list/MarkedListTextBlock';

interface ISeoMarkedListProps {
  items: IMarkedListTextBlock[];
}

export const SeoMarkedList: React.FC<ISeoMarkedListProps> = ({ items }) => (
  <div className={styles['container']} style={{ order: 1 }}>
    {items.map((item, index) => {
      const id = `SeoMarkedListItem_${index}`;

      return <SeoMarkedListItem key={id} id={id} {...item} />;
    })}
  </div>
);
